import { map } from 'rxjs/operators';
import { combineLatest } from 'rxjs';

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { FleetCardsOrdersService } from '@app/admin/fleet-card/orders/orders.service';
import { FleetCardsFeatureFlagService } from '@services/feature-flags/fleet-cards';
import { FleetCardsDataService } from '@services/fleet-cards-data';

import { IEligibilityCheck } from '@app/admin/fleet-card/orders/checkout/checkout-form-config/interfaces';
import { IFleetCardCompany } from '@app/admin/fleet-card/shared/fleet-cards-waitlist/fleet-cards-waitlist.interface';

import { CARD_APPLICATION_STATUS } from '@app/admin/fleet-card/main.constants';

@Injectable()
export class FleetCardsOrderEligibilityGuard {
  private isFleetCardsCardOrderImprovementsEnabled: boolean = false;

  constructor(
    private ordersService: FleetCardsOrdersService,
    private router: Router,
    private fleetCardsDataService: FleetCardsDataService,
    private fleetCardFeatureFlagService: FleetCardsFeatureFlagService,
  ) { }

  public canActivate(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    const shouldBypassGuard: boolean = !!this.router.getCurrentNavigation()?.extras?.state?.bypassGuard;
    if (shouldBypassGuard) return true;
    
    // Adding isFleetCardsCardOrderPublicAppEnabled to control public app card orders roll back
    return combineLatest([this.ordersService.isCompanyEligible(), this.fleetCardsDataService.getCachedCompanyMetadata()])
      .pipe(map(([response, company]: [IEligibilityCheck, IFleetCardCompany]) => {

      this.isFleetCardsCardOrderImprovementsEnabled = 
        this.fleetCardFeatureFlagService.isFleetCardsCardOrderImprovementsEnabled() ||
        (this.fleetCardFeatureFlagService.isFleetCardsCardOrderPublicAppEnabled() && company.cardApplication.publicApp);

      const isFirstCardOrderNumberAvailable: boolean =
        this.isFleetCardsCardOrderImprovementsEnabled && activatedRouteSnapshot.queryParamMap.has('order-number');

      if (isFirstCardOrderNumberAvailable) {
        return true;
      }

      if (response.eligible && company.cardApplication?.status === CARD_APPLICATION_STATUS.issued) return true;
      this.router.navigate(['admin/fleet-cards/orders']);
      return false;
    }));
  }
}